import { defineComponent, computed } from 'vue';
import { ExclamationCircleFilled } from '@ant-design/icons-vue';
import { ContestPlatformVals, downloadChrome } from '@/utils';
import { useService } from '@kaokei/use-vue-service';
import { EnvCheckService } from '@/services/exam/envCheck.service';
import { useRoute } from 'vue-router';
export default defineComponent({
  name: 'UserEnvCheckStage3',
  components: {
    ExclamationCircleFilled: ExclamationCircleFilled
  },
  setup: function () {
    var envCheckService = useService(EnvCheckService);
    var route = useRoute();
    var isNocFlag = computed(function () {
      return route.query.platform ? ContestPlatformVals.includes(route.query.platform) : false;
    });
    return {
      downloadChrome: downloadChrome,
      isNocFlag: isNocFlag,
      envCheckService: envCheckService
    };
  }
});